import { Component, OnInit, TemplateRef, ElementRef, ViewChild } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { CanonicalService } from '../../shared/canonical.service';
import { environment } from '../../../environments/environment';
declare var jQuery: any;
import * as AWS from "aws-sdk";
import SwiperCore, { Autoplay } from 'swiper';
import { DomSanitizer } from '@angular/platform-browser';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
SwiperCore.use([Autoplay]);
declare function filterSelection(one: any, two: any): any;
import { HttpService } from 'src/app/http.service';
import * as moment from 'moment';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-career',
  templateUrl: './career.component.html',
  styleUrls: ['./career.component.css'],
})
export class CareerComponent implements OnInit {

  applyForm: FormGroup;
  jobbyfun = "all";
  location = "all";
  innerWidth: number = window.innerWidth;
  demoSubmitted = false;

  heading = "Aim Higher, Reach Farther, Dream Bigger";
  subheading = "Be a #Protecttor by joining our diverse group of innovators working together to solve complex Mobile Cyber Security challenges.";

  modalRef!: BsModalRef;
  s3: any;
  videoUrl: string = '';
  cilentIPAddress = '';
  currentRoutePath: any;
  activeVideoIndex:number = 0;
  careerVideos:any = [
    {
      'poster': '../../../assets/images/careers/employee_speak_1.webp',
      'video': 'video/employee_speak.mp4',
      'title': 'Life at Protectt.ai - The Spirit of Protecttors'
    },{
      'poster': '../../../assets/images/careers/employee_speak_2.webp',
      'video': 'video/Protecttor (1).mp4',
      'title': "Be a Protecttor - Let's work together"
    },{
      'poster': '../../../assets/images/careers/employee_speak_3.webp',
      'video': 'video/life at protectt.ai 2 final.mp4',
      'title': 'Life at Protectt.ai - Be a Protecttor and build a future you believe in'
    }
  ]

  slides1 = [
    
    { img: "assets/images/careers/event images/birthday_celebration_3.webp" },
    { img: "assets/images/careers/event images/diwali_celebratio_1n.webp" },
    { img: "assets/images/careers/event images/diwali_celebratio_2.webp" },
    { img: "assets/images/careers/event images/diwali_celebratio_3.webp" },
    { img: "assets/images/careers/event images/Inauguration_2.webp" },
    { img: "assets/images/careers/event images/pongal_celebration.webp" },
    { img: "assets/images/careers/event images/team_building_activity.webp" },
    { img: "assets/images/careers/event images/team_lunch.webp" },
    { img: "assets/images/careers/event images/cricket_1.webp" },
    { img: "assets/images/careers/event images/cricket_2.webp" },
    { img: "assets/images/careers/event images/cricket_3.webp" },
    { img: "assets/images/careers/event images/cricket_4.webp" },
    { img: "assets/images/careers/event images/team1.webp" },
    { img: "assets/images/careers/event images/team2.webp" },
    { img: "assets/images/careers/event images/team3.webp" },
    { img: "assets/images/careers/event images/team5.webp" },
    { img: "assets/images/careers/event images/team4.webp" },
    { img: "assets/images/careers/event images/team6.webp" },
    { img: "assets/images/careers/event images/D_celeberation_1_23.webp" },
    { img: "assets/images/careers/event images/D_celeberation_2_23.webp" },
    { img: "assets/images/careers/event images/D_celeberation_3_23.webp" },
    { img: "assets/images/careers/event images/D_celeberation_4_23.webp" },
    { img: "assets/images/careers/event images/D_celeberation_5_23.webp" },
    { img: "assets/images/careers/event images/D_celeberation_6_23.webp" },
  ];

  constructor(private modalService: BsModalService, private titleService: Title, private metaTagService: Meta, private metaTagService1: Meta, private canonicalService: CanonicalService, private domSanitizer: DomSanitizer, public fb: FormBuilder, private httpService: HttpService, public router: Router) {
    this.canonicalService.setCanonicalURL("https://www.protectt.ai/careers");

    this.currentRoutePath = this.router.url;
    this.httpService.getIPAddress().subscribe((res: any) => {
      this.cilentIPAddress = res.ip;
    });

    this.applyForm = this.fb.group({
      linkedinprofile: [''],
      resumeorcv: ['', Validators.compose([Validators.required])],
      name: ['', Validators.compose([Validators.required, Validators.maxLength(30), Validators.pattern('^[A-Za-z ]+$')])],
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]{1,64}@[a-z0-9.-]+\\.[a-z]{2,4}$')])],
      contactnumber: ['', Validators.compose([Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")])],
      company_name: ['', Validators.compose([Validators.required])],
      currentctc: ['', Validators.compose([Validators.required])],
      noticeperiod: ['', Validators.compose([Validators.required])],
      currentlocation: ['', Validators.compose([Validators.required])],
      message: [''],
    });
  }

  ngOnInit(): void {
    this.titleService.setTitle('Careers | Group of Innovators | Protectt.ai ');
    this.metaTagService1.updateTag({ name: 'title', content: 'Careers | Protectt.ai' });
    this.metaTagService.updateTag({ name: 'description', content: 'Protectt.ai is a smart growing company Specializing in mobile security, wifi security, cloud security and digital security. Check out our current job postings.', });

    // lightbox
    $('ul#gallery a').on('click', function (event) {
      event.preventDefault();
      var link = $(this).find('img').attr('src') || 0;
      $('.gallery img').attr('src', '');
      $('.gallery img').attr('src', link);
      $('.gallery').fadeIn('slow');
    });
    // close lightbox
    $('.gallery').on('click', function (event) {
      event.preventDefault();
      $('.gallery').fadeOut('slow');
    });

    
    var that = this;
    $('#playEmplyoeeVideo').on('hidden.bs.modal', function (e) {
      that.videoUrl = '';
    })

  }

  onClickPdfView(filename: any) {
    let AKey;
    let SKey;
    let url = environment.API_URL + "fetchbucketcred"
    this.httpService.getAPI(url).then((resp: any) => {
      // console.log(resp);
      let decRes = this.httpService.decryptText(resp, HttpService.SECRET_KEY);
      let decMsg = JSON.parse(decRes);
      // console.log(decMsg?.lkpList);
      // console.log(decMsg?.lkpList[0].lkpvalue);
      // console.log(decMsg?.lkpList[1].lkpvalue);

      AKey = decMsg?.lkpList[0].lkpvalue;
      SKey = decMsg?.lkpList[1].lkpvalue;


      AWS.config.update({
        accessKeyId: AKey,
        secretAccessKey: SKey,
        region: "ap-south-1",
      });
      this.s3 = new AWS.S3();
      // console.log(this.s3);
      setTimeout(() => {
        let logo = "datasheets/" + filename;

        // console.log(logo)
        const url = this.s3.getSignedUrl("getObject", {
          Bucket: environment.Bucket,
          Key: filename,
          Expires: 600,
        });
        // console.log(url);
        this.videoUrl = url || '';
        //window.open(this.pdfPath, "_blank");
      }, 500);
    });
  }

  storeLocation(place: any) {
    this.location = place;
    jQuery('#selector-location')[0].innerHTML = place;
    this.filter();
  }
  storeJob(job: any) {
    this.jobbyfun = job;
    jQuery('#selector-job')[0].innerHTML = job;
    this.filter();
  }
  filter() {
    filterSelection(this.location, this.jobbyfun);
  }
  onResize(event: any) {
    this.innerWidth = event.target.innerWidth;
  }

  getMainContentTrusted(value: any) {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(value);
  }

  get getDemoForm() {
    return this.applyForm.controls;
  }

  submitDemoForm() {
    // let dateString1 = this.applyForm.get('time_slot1')!.value;
    // let dateString2 = this.applyForm.get('time_slot2')!.value;
    // var dateTimeSlot1 = moment(dateString1).format('DD-MM-YYYY HH:MM');
    // var dateTimeSlot2 = moment(dateString2).format('DD-MM-YYYY HH:MM');
    let url = environment.API_URL + "requestdemo";
    let urlValue = "";
    this.demoSubmitted = true;
    if (this.applyForm.invalid) {
      return;
    } else {
      if (url.includes("dev.website")) {
        urlValue = "nonprod"
      } else {
        urlValue = "prod"
      }
      var demoData = {
        linkedinprofile: this.applyForm.get('linkedinprofile')!.value,
        resumeorcv: this.applyForm.get('resumeorcv')!.value,
        email: this.applyForm.get('email')!.value,
        name: this.applyForm.get('name')!.value,
        contactnumber: this.applyForm.get('contactnumber')!.value,
        company_name: this.applyForm.get('company_name')!.value,
        currentctc: this.applyForm.get('currentctc')!.value,
        noticeperiod: this.applyForm.get('noticeperiod')!.value,
        currentlocation: this.applyForm.get('currentlocation')!.value,
        message: this.applyForm.get('message')!.value,
        ipaddress: this.cilentIPAddress,
        weburl: urlValue,
        adcampurl: this.currentRoutePath,
       
      };
      let data = {
        careerLeadData: demoData,
      }
      let encryptMsg = JSON.stringify(data);
      let encMsg = this.httpService.encryptText(encryptMsg, HttpService.SECRET_KEY);
      let postData = {
        encryptedRequest: encMsg
      }

      this.httpService.postAPIMethod(url, postData).subscribe(
        res => {
          let decRes = this.httpService.decryptText(res, HttpService.SECRET_KEY);
          let decMsg = decRes;
          let resp: any = JSON.parse(decMsg);
          alert(resp['statusDesc']);
          // this.subRespData = JSON.parse(decMsg);
        },
        error => {
        });


      this.demoSubmitted = false;
      // alert("Request has been submitted..");
      this.router.navigateByUrl('/appbindthankyou ');
    }
  }

  async uploadFiletoS3Trigger(data:any){
    await this.uploadFiletoS3(data);
  }

  uploadFiletoS3(event:any){
    var datePipe = new DatePipe('en-US')
    // console.log('s3 upload',event);
    var fileData = event.target.files.item(0) || '';
    if(fileData == ''){
      alert('Upload valid files..');
      return;
    }else{
      
    // const contentType = fileData.type;
    //   const params = {
    //       Bucket: environment.Bucket, 
    //       Key: datePipe.transform(new Date(), 'dd/MM/yyyy') + fileData.name,
    //       Body: fileData,
    //       ACL: 'public-read',
    //       ContentType: contentType
    //   };
    //   this.s3.upload(params, function (err:any, data:any) {
    //       if (err) {
    //           console.log('There was an error uploading your file: ', err);
    //           return false;
    //       }
    //       console.log('Successfully uploaded file.', data);
    //       return true;
    //   });
    
    let fileNameOfObject = fileData.name;
    let currentDateTime = new Date();

    let formattedDateTime = datePipe.transform(currentDateTime, 'dd-MM-yyyy/');
    console.log(formattedDateTime)


    return new Promise((resolve, reject) => {
      const params = {
        Bucket: environment.Bucket,
        Key: environment.resume_folder + formattedDateTime + fileData.name,
        Body: fileData,
      };
      var bucket = new AWS.S3();
      bucket.upload(params, function (err: any, data: any) {
        if (err) {
          console.log('There was an error uploading your file: ', err);
          reject(err);
        }
        data.isUploadedSuccessfully = true;
        localStorage.setItem('s3FileUploaded', JSON.stringify(data));
        console.log('Successfully uploaded file.', data);
        resolve(data);

      });

    });

//for upload progress   
/*bucket.upload(params).on('httpUploadProgress', function (evt) {
          console.log(evt.loaded + ' of ' + evt.total + ' Bytes');
      }).send(function (err, data) {
          if (err) {
              console.log('There was an error uploading your file: ', err);
              return false;
          }
          console.log('Successfully uploaded file.', data);
          return true;
      });*/
    }
  }

}

function addCustomSlickAttributes() {
  $("[data-my-slick-attr]").removeAttr("data-my-slick-attr");

  $(".slick-active").each(function (index, el) {
    $(el).attr("data-my-slick-attr", index);
  });
}